import { createSelector } from "@reduxjs/toolkit";
import { rootState } from "../../../../../../../redux/store";

export const selectorKnowledgeGraph = createSelector(
    (state: rootState) => state.knowladgeGraphDiff,
    (state: rootState) => state.loginUserAndTokenData,
    (state: rootState) => state.knowledgeGraphForSending,
    (state: rootState) => state.knowledgeGraphMerge,


    (knowladgeGraphDiff, loginUserAndTokenData, knowledgeGraphForSending, knowledgeGraphMerge) => {
        return  {
            knowladgeGraphDiff,
            loginUserAndTokenData,
            knowledgeGraphForSending,
            knowledgeGraphMerge
        }
    }
);